var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "cloum" },
        [
          _vm.applyType === "signList"
            ? [
                _vm.rowData.signStatus === 2
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "color-success",
                          on: {
                            click: function($event) {
                              _vm.refuseResonVisible = true
                            }
                          }
                        },
                        [_vm._v("查看拒签原因")]
                      )
                    ]
                  : _vm._e(),
                _vm.rowData.signStatus === 0
                  ? [
                      _vm.rowData.selfSign === 1
                        ? _c(
                            "span",
                            {
                              staticClass: "color-success",
                              on: {
                                click: function($event) {
                                  return _vm.toSign()
                                }
                              }
                            },
                            [_vm._v("签署")]
                          )
                        : [
                            _vm.rowData.isReminderSign === 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.reminderSign(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("再催")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.reminderSign(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("催签")]
                                )
                          ],
                      _vm.rowData.myCreate === 1
                        ? _c(
                            "span",
                            {
                              staticClass: "color-success",
                              on: {
                                click: function($event) {
                                  return _vm.batchCancel(_vm.rowData)
                                }
                              }
                            },
                            [_vm._v("撤销")]
                          )
                        : _vm._e(),
                      _vm.rowData.myCreate === 1 &&
                      _vm.rowData.applySignCreateType !== 0 &&
                      _vm.rowData.createType !== 0
                        ? _c(
                            "span",
                            {
                              staticClass: "color-success",
                              on: {
                                click: function($event) {
                                  return _vm.getNoSingInfo(_vm.rowData.applyNo)
                                }
                              }
                            },
                            [_vm._v("链接")]
                          )
                        : _vm._e()
                    ]
                  : _vm.rowData.signStatus === -3
                  ? [
                      _vm.rowData.myCreate === 1
                        ? _c(
                            "span",
                            {
                              staticClass: "color-success",
                              on: {
                                click: function($event) {
                                  return _vm.batchCancel(_vm.rowData)
                                }
                              }
                            },
                            [_vm._v("撤销")]
                          )
                        : _vm._e(),
                      _vm.rowData.selfApprove == 1 && !_vm.isInDingTalk
                        ? _c("div", { staticClass: "cloum" }, [
                            _c(
                              "span",
                              {
                                staticClass: "color-success",
                                on: {
                                  click: function($event) {
                                    return _vm.clickHanldeAuditRefuse(1)
                                  }
                                }
                              },
                              [_vm._v("同意")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "color-success",
                                on: {
                                  click: function($event) {
                                    return _vm.clickHanldeAuditRefuse(2)
                                  }
                                }
                              },
                              [_vm._v("拒绝")]
                            )
                          ])
                        : _vm._e()
                    ]
                  : _vm._e()
              ]
            : _vm.applyType === "applyList"
            ? [
                _vm.rowData.signStatus === 2
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "color-success",
                          on: {
                            click: function($event) {
                              _vm.refuseResonVisible = true
                            }
                          }
                        },
                        [_vm._v("查看拒签原因")]
                      )
                    ]
                  : _vm._e(),
                _vm.rowData.signStatus === 0
                  ? [
                      _vm.rowData.selfSign === 1
                        ? [
                            _c(
                              "span",
                              {
                                staticClass: "color-success",
                                on: {
                                  click: function($event) {
                                    return _vm.toSign()
                                  }
                                }
                              },
                              [_vm._v("签署")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "color-success",
                                on: {
                                  click: function($event) {
                                    return _vm.batchCancel(_vm.rowData)
                                  }
                                }
                              },
                              [_vm._v("撤销")]
                            )
                          ]
                        : [
                            _vm.rowData.myCreate === 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.batchCancel(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("撤销")]
                                )
                              : _vm._e(),
                            _vm.rowData.isReminderSign === 1 &&
                            _vm.rowData.myCreate === 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.reminderSign(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("再催")]
                                )
                              : _vm.rowData.myCreate === 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.reminderSign(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("催签")]
                                )
                              : _vm._e(),
                            _vm.rowData.myCreate === 1 &&
                            _vm.rowData.applySignCreateType !== 0 &&
                            _vm.rowData.createType !== 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.getNoSingInfo(
                                          _vm.rowData.applyNo
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("链接")]
                                )
                              : _vm._e()
                          ]
                    ]
                  : _vm.rowData.signStatus === -3
                  ? [
                      _vm.rowData.myCreate === 1
                        ? _c(
                            "span",
                            {
                              staticClass: "color-success",
                              on: {
                                click: function($event) {
                                  return _vm.batchCancel(_vm.rowData)
                                }
                              }
                            },
                            [_vm._v("撤销")]
                          )
                        : _vm._e(),
                      _vm.rowData.selfApprove !== 1 &&
                      _vm.rowData.myCreate === 1 &&
                      _vm.rowData.fromDingTalk !== 1 &&
                      !_vm.isInDingTalk
                        ? [
                            +_vm.rowData.isReminderApprova === 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.urgeForTrial(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("已催审")]
                                )
                              : _vm._e(),
                            +_vm.rowData.isReminderApprova === 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "color-success",
                                    on: {
                                      click: function($event) {
                                        return _vm.urgeForTrial(_vm.rowData)
                                      }
                                    }
                                  },
                                  [_vm._v("催审")]
                                )
                              : _vm._e()
                          ]
                        : _vm._e()
                    ]
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "获取签署链接",
            visible: _vm.visibleNoSignList,
            "modal-append-to-body": "",
            "append-to-body": "",
            "close-on-click-modal": false,
            "show-close": true,
            width: "550px",
            "custom-class": "my-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleNoSignList = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    value: _vm.noSign.signNo,
                    placeholder: "选择待签署方"
                  },
                  on: {
                    input: function(val) {
                      _vm.dselect(val)
                    }
                  }
                },
                _vm._l(_vm.noSign.data, function(item) {
                  return _c("el-option", {
                    key: item.signNo,
                    staticClass: "my-dialog-select",
                    attrs: { label: item.fullName, value: item.signNo }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex", staticStyle: { margin: "15px auto" } },
            [_vm._v("将下方二维码或链接复制发送给对方，即可进行签署。")]
          ),
          _c("div", { staticClass: "flex dashed" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "div",
                  { staticClass: "qrcode" },
                  [
                    _vm.showQy
                      ? _c("qrcode", {
                          key: "evidence",
                          attrs: {
                            value: _vm.noSign.url,
                            size: 140,
                            leave: "H"
                          }
                        })
                      : _c("span", { staticClass: "ne-text" }, [
                          _vm._v("请先选择签署方")
                        ])
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "b-btn",
                    attrs: { disabled: !_vm.showQy },
                    on: { click: _vm.saveQr }
                  },
                  [_vm._v("保存二维码")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "div",
                  {
                    staticStyle: { padding: "10px", "box-sizing": "border-box" }
                  },
                  [
                    _vm.showQy
                      ? [_vm._v(_vm._s(_vm.noSign.url))]
                      : _c("span", { staticClass: "ne-text" }, [
                          _vm._v("请先选择签署方")
                        ])
                  ],
                  2
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "b-btn",
                    attrs: {
                      disabled: !_vm.showQy,
                      id: "tag-copy",
                      "data-clipboard-text": _vm.noSign.url
                    },
                    on: {
                      click: function($event) {
                        return _vm.copyText($event)
                      }
                    }
                  },
                  [_vm._v("复制签署链接")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogAuditRefuseVisible,
            title: _vm.refuseModel.flowStatus === 2 ? "拒绝原因" : "审批意见",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogAuditRefuseVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticStyle: { position: "relative" } },
                  [
                    _c("el-input", {
                      ref: "textareaReasonRef",
                      attrs: {
                        type: "textarea",
                        rows: "5",
                        resize: "none",
                        autofocus: true,
                        size: "small",
                        maxlength: 100,
                        placeholder:
                          _vm.refuseModel.flowStatus === 2
                            ? "请输入拒绝原因"
                            : "请输入审批意见"
                      },
                      model: {
                        value: _vm.refuseModel.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.refuseModel, "reason", $$v)
                        },
                        expression: "refuseModel.reason"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          bottom: "10px",
                          right: "10px",
                          color: "red"
                        }
                      },
                      [_vm._v(_vm._s(_vm.refuseModel.reason.length) + "/100")]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "el-col",
                { staticStyle: { height: "24px" }, attrs: { span: 24 } },
                [
                  _vm.refuseModel.errorMessage
                    ? _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm.refuseModel.errorMessage))
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _c(
            "p",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialogAuditRefuseVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.clickHandleRefuseSubmit()
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "拒签原因",
            visible: _vm.refuseResonVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.refuseResonVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("p", [
              _vm._v(
                "签约方：" +
                  _vm._s(
                    _vm.rowData.signInfoVOS && _vm.rowData.signInfoVOS.length
                      ? _vm.rowData.signInfoVOS[0].signatoryFullName
                      : "--"
                  )
              )
            ]),
            _c("div", [
              _vm._v(
                "拒签原因：" +
                  _vm._s(
                    _vm.rowData.signInfoVOS && _vm.rowData.signInfoVOS.length
                      ? _vm.rowData.signInfoVOS[0].refuseReason
                      : "--"
                  )
              )
            ])
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.refuseResonVisible = false
                    }
                  }
                },
                [_vm._v("关闭")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3921b76c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3921b76c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/corpHandles.vue
// module id = U2o4
// module chunks = 27 31 41 42